import CardsInformationSlider from "./CardsInformationSlider";

export default CardsInformationSlider;